import { Edit, FormTab, ImageField, ImageInput, TabbedForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { ColorPicker } from '../../components/ColorPicker';
import { EditMenu } from './EditMenu';
import { EditImages } from './editImages';

export const ConfigsEdit = () => (
  <Edit title={<CustomTitle />}>
    <TabbedForm /*toolbar={<ToolbarP />} */>
      <FormTab label="Congress">
        <TextInput fullWidth source="congress_name" label="name" />
        <TextInput fullWidth source="congress_url" label="url" />
      </FormTab>

      <FormTab label="Share">
        <TextInput fullWidth source="share_title" label="title" />
      </FormTab>

      <FormTab label="Export">
        <TextInput fullWidth source="export_title" label="title" />
        <TextInput fullWidth source="export_item_title" label="Item title" />
      </FormTab>
      <FormTab label="Images">
        <EditImages />
      </FormTab>

      <FormTab label="Menú">
        <EditMenu />
      </FormTab>

      <FormTab label="App">
        <TextInput
          fullWidth
          source="otaUpdateMessage"
          label="Mensaje de actualización disponible"
          placeholder="Actualización disponible: tocá para reiniciar"
          helperText='Se muestra en el menú lateral cuando ya se descargó una versión nueva. Al tocarlo la app se reinicia y la aplica. Vacío = "Actualización disponible: tocá para reiniciar".'
        />
      </FormTab>

      <FormTab label="Colors">
        <ColorPicker source="color_primary_50" label="Primary 50" help="footer background" />
        <ColorPicker source="color_primary_100" label="Primary 100" help="unused" />
        <ColorPicker source="color_primary_200" label="Primary 200" help="lists divider, favIcon selected color" />
        <ColorPicker source="color_primary_300" label="Primary 300" help="unused" />
        <ColorPicker source="color_primary_400" label="Primary 400" help="unused" />
        <ColorPicker
          source="color_primary_500"
          label="Primary 500"
          help="avatar bg, 2-list heading, drawer selectd fg, main-screen icon/text color, export/notes/share/favorites/filter/sort big-button bg, filter"
        />
        <ColorPicker source="color_primary_600" label="Primary 600" help="unused" />
        <ColorPicker source="color_primary_700" label="Primary 700" help="unused" />
        <ColorPicker source="color_primary_800" label="Primary 800" help="unused" />
        <ColorPicker source="color_primary_900" label="Primary 900" help="unused" />

        <ColorPicker source="color_secondary_50" label="Secondary 50" help="unused" />
        <ColorPicker source="color_secondary_100" label="Secondary 100" help="unused" />
        <ColorPicker source="color_secondary_200" label="Secondary 200" help="unused" />
        <ColorPicker source="color_secondary_300" label="Secondary 300" help="unused" />
        <ColorPicker source="color_secondary_400" label="Secondary 400" help="unused" />
        <ColorPicker source="color_secondary_500" label="Secondary 500" help="unused" />
        <ColorPicker source="color_secondary_600" label="Secondary 600" help="unused" />
        <ColorPicker source="color_secondary_700" label="Secondary 700" help="unused" />
        <ColorPicker source="color_secondary_800" label="Secondary 800" help="unused" />
        <ColorPicker source="color_secondary_900" label="Secondary 900" help="unused" />
      </FormTab>
    </TabbedForm>
  </Edit>
);
